const value = {
    completionTimeAndReward: 'Completion time and reward',
    completionTime: 'Passage time',
    completionTimeDescription:
      'Specify the approximate amount of time that the employee will spend on passing the test. This helps to plan the training.',
    awardDescription:
      'An employee can receive a maximum of 15 points for passing the test. The final result depends on the number of questions that he or she answered correctly.',
  };

export default value;
